/** * 左边菜单 */
<template>
  <div class="logobox">
    <!-- <label>四川省医院感染管理质量控制中心</label> -->
    <label>四川省医院感染质控平台</label>
    <img class="logoimg" src="../assets/img/logo.png" alt="" />
    <el-row class="tac">
      <el-col :span="12">
        <el-menu default-active="2" class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
          active-text-color="#ffd04b">
          <el-menu-item index="1" @click="toUrl('goods/Goods')">
            <i class="el-icon-house"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-office-building"></i>
              <span>医院感染监测数据集</span>
            </template>
            <el-menu-item-group>
              <el-menu-item @click="toUrl('machine/Machine')" index="2-1"><i
                  class="el-icon-upload"></i>感染监测数据上报</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item @click="toUrl('machine/MachineAisle')" index="2-2">
                <i class="el-icon-data-line"></i>感染监测数据分析</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item @click="toUrl('charts/prevalence')" index="2-3"><i
                  class="el-icon-upload2"></i>现患率数据上报</el-menu-item>
            </el-menu-item-group>
            <!-- <el-menu-item-group>
              <el-menu-item @click="toUrl('charts/handhygiene')" index="2-4"><i
                  class="el-icon-edit-outline"></i>CRKP调查表</el-menu-item>
            </el-menu-item-group> -->
            <el-menu-item-group>
              <el-menu-item @click="toUrl('charts/handhygiene')" index="2-5"><i
                  class="el-icon-thumb"></i>手卫生上报</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="3" @click="toUrl('charts/statistics')">
            <i class="el-icon-document"></i>
            <span slot="title">感染评审</span>
          </el-menu-item>
          <el-menu-item index="4" @click="toUrl('charts/indicators')">
            <i class="el-icon-tickets"></i>
            <span slot="title">12项指标</span>
          </el-menu-item>
          <el-menu-item index="5" @click="toUrl('system/user')">
            <i class="el-icon-edit-outline"></i>
            <span slot="title">专职人员登记</span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { touch } from "shelljs";

export default {
  name: "leftnav",
  data() {
    return {};
  },
  mounted() { },
  methods: {
    toUrl(url) {
      this.$router.push({ path: "/" + url });
    },
  },
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 230px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {
  height: 40px;
  line-height: 40px;
  color: white;
  /*#9d9d9d;*/
  font-size: 16px;
  text-align: center;
  padding: 20px 0px;
}

.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue